export const COLOR_FILTER = [
  {
    label: 'ABU-ABU',
    value: '#808080',
    enLabel: 'GREY',
  },
  {
    label: 'BIRU',
    value: '#4A68D9',
    enLabel: 'BLUE',
  },
  {
    label: 'COKELAT',
    value: '#965535',
    enLabel: 'BROWN',
  },
  {
    label: 'HIJAU',
    value: '#377E21',
    enLabel: 'GREEN',
  },
  {
    label: 'HITAM',
    value: '#000000',
    enLabel: 'BLACK',
  },
  {
    label: 'KUNING',
    value: '#F9D949',
    enLabel: 'YELLOW',
  },
  {
    label: 'MERAH',
    value: '#EA3322',
    enLabel: 'RED',
  },
  {
    label: 'ORANYE',
    value: '#F2A83A',
    enLabel: 'ORANGE',
  },
  {
    label: 'PURPLISH SILVER',
    value: '#000000',
    enLabel: 'PURPLISH SILVER',
  },
  {
    label: 'PUTIH',
    value: '#FFFFFF',
    enLabel: 'WHITE',
  },
  {
    label: 'SILVER',
    value: '#C0C0C0',
    enLabel: 'SILVER',
  },
  {
    label: 'UNGU',
    value: '#75147C',
    enLabel: 'PURPLE',
  },
];

export const COLOR_FILTER_LIST = [
  {
    label: 'ABU-ABU',
    value: ['#808080'],
    enLabel: 'SILVER METALLIC',
  },
  {
    label: 'MERAH DAN HITAM',
    value: ['#EA3322', '#000000'],
    enLabel: 'RED AND BLACK',
  },
  {
    label: 'BIRU DAN HITAM',
    value: ['#4A68D9', '#000000'],
    enLabel: 'BLUE AND BLACK',
  },
  {
    label: 'KUNING',
    value: ['#F9D949'],
    enLabel: 'YELLOW',
  },
  {
    label: 'BIRU',
    value: ['#4A68D9'],
    enLabel: 'BLUE',
  },

  {
    label: 'ORANYE',
    value: ['#F2A83A'],
    enLabel: 'ORANGE',
  },
  {
    label: 'PUTIH',
    value: ['#FFFFFF'],
    enLabel: 'WHITE',
  },
];
